import { render, staticRenderFns } from "./AddPackagesDetails.vue?vue&type=template&id=4b55dd7c&"
import script from "./AddPackagesDetails.vue?vue&type=script&lang=js&"
export * from "./AddPackagesDetails.vue?vue&type=script&lang=js&"
import style0 from "./AddPackagesDetails.vue?vue&type=style&index=0&id=4b55dd7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports